import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'
import { device } from '../../../utils/helpers'

const secondary = css`
  color: ${props => props.theme.color.textPrimary || '#4d4d4d'};
  background-color: white;
`

const white = css`
  color: #4d4d4d;
  background-color: white;
  border: 5px solid #fff;
`

const link = css`
  text-align: center;
  text-decoration: none;
`

const StyledBase = styled.button`
  font-family: 'BarlowExtraBold';
  display: inline-block;
  outline: none;
  color: ${props => props.theme.color.textSecondary || '#fff'};
  border: 5px solid ${props => props.theme.color.borderPrimary || '#4d4d4d'};
  background-color: ${props => props.theme.color.bgDark || '#4d4d4d'};
  text-transform: uppercase;
  font-size: 14px;
  padding: 12px 20px;
  transition: all 0.5s ease;
  cursor: pointer;

  @media ${device.mobileL} {
    ${'' /* font-size: ${props => props.size === 'small' && '12px'};
    padding: ${props => props.size === 'small' && '10px 2px'}; */}
    width: ${props => props.mobileBig ? '100%' : 'auto'};
  }

  &:hover {
    color: white;
    background-color: ${props => props.theme.color.hoverPrimary};
    border: 5px solid ${props => props.theme.color.borderSecondary};
  }

  ${props => (props.secondary ? secondary : undefined)}

  ${props => (props.white ? white : undefined)}

  @media ${device.tablet} {
    ${'' /* font-size:  ${props => props.size === 'large' ? '36px' : '27px'};
  padding: ${props => props.size === 'large' ? '35px 55px' : '24px 40px'}; */}
    font-size:  ${props => props.size === 'large' ? '1.875vw' : '1.40625vw'};
    padding: ${props => props.size === 'large' ? '1.8229166666666667vw 2.8645833333333335vw' : '1.25vw 2.0833333333333335vw'};
  }
`

const StyledLink = StyledBase.withComponent(Link).extend`
  ${link}
`

const StyledATag = StyledBase.withComponent('a').extend`
  ${link}
`

const Button = ({ href, to, children, onClick, disabled, ...props }) => {
  // If href return `a` tag
  if (href) {
    return (
      <StyledATag href={href} {...props}>{children}</StyledATag>
    )
  }

  // If link return Link component
  if (to) {
    return (
      <StyledLink to={to} {...props}>{children}</StyledLink>
    )
  }

  // Returns button by default
  return (
    <StyledBase disabled={disabled} onClick={onClick} {...props}>{children}</StyledBase>
  )
}

Button.propTypes = {
  /**
   * Pass an href prop to make the button an `a` element instead of a `button`
   */
  href: PropTypes.string,

  /**
   * Pass a to prop to make the button a `Link` element instead of a `button`
   */

  to: PropTypes.string,

  /**
   * Function to run when the button is clicked
   */
  onClick: PropTypes.func,

  /**
   * Content for the button
   */
  children: PropTypes.node.isRequired,

  /**
   * Disable button
   */
  disabled: PropTypes.bool,

  /**
   * Give secondary button styles
   */
  secondary: PropTypes.bool,

  /**
   * Give white button styles
   */
  white: PropTypes.bool,

  /**
   * Specify size of button - large/small
   */
  size: PropTypes.string
}

Button.defaultProps = {
  href: null,
  to: null,
  onClick: null,
  size: 'large',
  children: 'Button',
  disabled: false,
  secondary: false,
  white: false
}

export default Button



// WEBPACK FOOTER //
// ./src/components/UI/Button/index.js